<template>
	<div>
		<div v-if="loading"><loading type="page" /></div>
		<div v-else-if="!active" class="inactive-page">
			<p>TASKBANK FOR THIS TENANT IS NOT ACTIVE.</p>
		</div>
		<div v-else id="content" class="app-content box-shadow-3">
			<div class="topbar">
				<div class="navbar theme-login bg box-shadow">
					<div>
						<a :href="`#/public/tasks/${refID}`" class="navbar-brand oscar-logo">
							<img :src="brand.logoHeader" alt="." class />
						</a>
					</div>
				</div>
				<section class="theme-login-light jumbotron text-center">
					<div class="container">
						<h1 class="jumbotron-heading">{{ taskbank.header_text }}</h1>
						<p v-html="taskbank.description" class="lead text-muted"></p>
					</div>
				</section>
			</div>
			<div class="main-content p-5">
				<div class="container py-2 text-center w-100 x page-shadow col-4 p-4">
					<template>
						<img
							style="max-width: 90%; opacity: 0.7; max-height: 300px"
							class="logo ng-scope pb-3"
							:src="brand.logo"
						/>
						<h1>Reset Password :</h1>

						<form @submit.prevent name="form" v-if="!token">
							<div class="form-group">
								<input
									v-model.trim="email"
									type="text"
									class="form-control form-control-lg"
									placeholder="Email"
									required
								/>
							</div>

							<button @click="resetPW()" type="submit" class="btn btn-block btn-lg theme-login">
								Reset Password
							</button>
						</form>

						<form @submit.prevent name="form" v-if="token">
							<p>Please enter a new password</p>
							<div class="form-group" :class="{ invalid: !valid.field('password') }">
								<label>New Password</label>
								<input type="password" class="form-control form-control-lg" v-model="password" />
							</div>
							<div class="form-group" :class="{ invalid: !valid.field('passwordMatch') }">
								<label>Confirm Password</label>
								<input type="password" class="form-control form-control-lg" v-model="password2" />
							</div>

							<button
								@click="newPW()"
								type="submit"
								class="btn btn-block btn-lg theme-login"
								:disabled="!valid.group('reset')"
							>
								Reset Password
							</button>

							<div class="mt-1 mb-0 text-xs text-muted" v-for="error in valid.errors()" :key="error">
								{{ error }}
							</div>
						</form>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.margin-overlap {
	margin-right: -2.5rem;
}

.jumbotron {
	color: white;
	border-radius: 0px;
}
.left-section {
	background: #f4f3ef;
	padding: 1rem;
	border: 1px solid #ccc;
}
.right-section {
	padding-left: 50px;
}
.taskLabel {
	display: inline-block;
	font-size: 0.875rem;
	font-family: "source_sans_prosemibold", Helvetica, Arial, sans-serif;
	color: #5f574f;
	text-transform: uppercase;
	margin: auto;
}
.mainContainer {
	border: 1px solid #ccc;
	padding: 10px;
}

.box {
	border: 1px solid #ccc;

	padding: 5px;
	margin-left: 10px;
}
.inner {
	background-color: #fff;
}
.loadMore {
	border-radius: 3px;
	font-family: "source_sans_prosemibold", Helvetica, Arial, sans-serif;
	display: inline-block;
	width: 100%;
	height: 3.125rem;
	margin: 0;
	padding: 0.5625rem 0.625rem;
	vertical-align: middle;
	background-color: #f3f3ee;
	color: #5f574f;
	font-size: 1rem;
	line-height: 2.125rem;
	letter-spacing: 0.0625rem;
	text-align: center;
	text-transform: uppercase;
	text-decoration: none;
}

div.inactive-page {
	padding-top: 500px;
	height: 10em;
	position: relative;
}
div.inactive-page p {
	margin: 0;
	position: absolute;
	font-size: 3rem;
	top: 50%;
	left: 50%;
	margin-right: -50%;
	transform: translate(-50%, -50%);
}
</style>


<script>
import EditPane from "@/components/EditPane";
import SaveOptionalModal from "@/components/SaveOptionalModal";
import ConfigSelect from "@/components/ConfigSelect";
import RichText from "@/components/RichText";
import PublicAssessmentRow from "@/components/assessment/PublicAssessmentRow";

import AssessmentService from "@/services/AssessmentService";
import ConfigService from "@/services/ConfigService";
import GradeService from "@/services/GradeService";
import DistrictService from "@/services/DistrictService";
import TaskBankService from "@/services/TaskBankService";
import ValidationService from "@/services/ValidationService";

import store from "@/services/Store";
import Router from "@/router";

import Notie from "@/services/NotieService";
import fs from "@/services/FormatService";
import BB from "bluebird";
import Utils from "@/services/Utils";
import moment from "moment";
import BrandService from "@/services/BrandService";
var brand = BrandService.getBrand();

export default {
	name: "BankLogin",

	props: ["id", "defaultTab", "valid"],

	components: {
		EditPane,
		SaveOptionalModal,
		ConfigSelect,
		RichText,
		PublicAssessmentRow,
	},

	data() {
		return {
			fs: fs,
			brand: brand,
			refresh: null,
			assessment: {},
			dirty: false,
			saveOptModal: false,
			saveOptNext: () => {},
			saveOptCancel: () => {},
			refID: this.$route.params.tenantID,
			taskbank: null,
			active: false,
			loading: true,
			token: null,
			password: null,
			password2: null,
		};
	},

	computed: {},
	created() {
		this.token = this.$route.query.token;
		this.loadTaskBankConfiguration();
		this.initValidation();
	},

	beforeRouteLeave(to, from, next) {
		if (this.dirty) {
			this.saveOptNext = () => {
				next();
			};
			this.saveOptCancel = () => {
				next(false);
			};
			this.saveOptModal = true;
		} else {
			next();
		}
	},

	methods: {
		initValidation() {
			this.valid = ValidationService.newValidator({
				anyPassword: {
					group: "reset",
					errorMsg: "You must provide a new password",
					func: () => {
						return this.password;
					},
				},
				password: {
					group: "reset",
					errorMsg: "Your password must be at least 5 characters long",
					func: () => {
						return !this.password || this.password.length >= 5;
					},
				},
				passwordMatch: {
					group: "reset",
					errorMsg: "Your passwords must match",
					func: () => {
						return !this.password || this.password == this.password2;
					},
				},
			});
		},
		loadTaskBankConfiguration() {
			TaskBankService.getPublicTaskBank(this.refID)
				.then((resp) => {
					this.loading = false;
					this.taskbank = resp.data;
					this.active = resp.data.active;
				})
				.catch((err) => {
					this.loading = false;
					console.log(err);
					// Notie.error("Failed to load public taskbank config", err);
				});
		},
		resetPW() {
			TaskBankService.resetPassword(this.email)
				.then((resp) => {
					Notie.success(
						`Reset email sent to ${this.email}`,
						"Check your email for a link to enter a new password"
					);
					Router.push({ path: `/public/login/${this.refID}` });
				})
				.catch((err) => {
					Notie.error("Something went wrong on login.");
					console.log(err);
				});
		},
		newPW() {
			TaskBankService.setNewPassword(this.token, this.password)
				.then((resp) => {
					Notie.success("Password reset");
					Router.push({ path: `/public/login/${this.refID}` });
				})
				.catch((err) => {
					Notie.error("Failed to reset password", err);
				});
		},
	},
};
</script>



// WEBPACK FOOTER //
// src/vues/Login/BankResetPW.vue